module.exports = __webpack_public_path__ + "img/file-search.2b4bfd4b.svg";